import React from 'react';
import PropTypes from 'prop-types';
import {
  
  IconBehance,
  IconDigitalOcean,
  IconDribbble,
  IconFacebook,
  IconGithub,
  IconInstagram,
  IconLinkedIn,
  IconMailto,
  IconNotion,
  IconTripadvisor,
  IconTwitter,
  IconPatreon,
  IconPaypal,
  IconStackoverflow,
  IconYoutube,
  IconUrl,
  IconToTop

} from './';

const Icon = ({ name }) => {
  switch (name) {
    case 'behance':
      return <IconBehance/>;
    case 'digitalocean':
     	return <IconDigitalOcean/>;
    case 'dribbble':
      return <IconDribbble/>;
    case 'facebook':
      return <IconFacebook/>;    
     case 'github':
     	return <IconGithub/>;
     case 'instagram':
     	return <IconInstagram/>;
     case 'linkedin':
     	return <IconLinkedIn/>;
     case 'mailto':
     	return <IconMailto/>;
     case 'notion':
     	return <IconNotion/>;
     case 'tripadvisor':
     	return <IconTripadvisor/>;
     case 'patreon':
     	return <IconPatreon/>;
     case 'paypal':
     	return <IconPaypal/>;
     case 'stackoverflow':
     	return <IconStackoverflow/>;
     case 'youtube':
     	return <IconYoutube/>;
     case 'twitter':
     	return <IconTwitter/>;

    case 'top':
      return <IconToTop/>;
    
    default:
      return <IconUrl/>;
  }
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
};

export default Icon;
